// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__1-9T2","rootSmall":"AddTileButton_rootSmall__2SnUo"};